unable to read source [project]/packages/src/components/base/form/slider/SliderTheme.tsx